import { render } from "./GameDetailView.vue?vue&type=template&id=0f95678e&scoped=true&ts=true"
import script from "./GameDetailView.vue?vue&type=script&lang=ts"
export * from "./GameDetailView.vue?vue&type=script&lang=ts"

import "./GameDetailView.vue?vue&type=style&index=0&id=0f95678e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f95678e"]])

export default __exports__